import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './firebase';
import { initConsoleLogger } from './utils/consoleLogger';

// Initialize console log forwarding to Firestore
// This allows debugging by reading logs from the backend
initConsoleLogger({
  enabled: true,
  levels: ['error', 'warn', 'log'],  // Capture all levels for full visibility
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
